import { TableCell, TableRow, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";

function ForSellerAdminRow(props) {
  const { request, columns, color } = props;
  let navigate = useNavigate();

  return (
    <>
      <TableRow
        sx={{ "& > *": { borderBottom: "unset" } }}
        style={{ backgroundColor: color }}
      >
        {columns.map((column, index) => {
          return (
            <TableCell
              component="th"
              scope="row"
              key={`${column.columnName}-${index}`}
            >
              {column.dbName === "company.social_reason" ? (
                request.company.social_reason
              ) : column.dbName === "created_at" ? (
                request.company.created_at.split("T")[0]
              ) : column.dbName === "actions" ? (
                <IconButton
                  onClick={() =>
                    navigate(`/home/company/${request.company.id}`)
                  }
                >
                  {" "}
                  <i className="material-icons">add</i>
                </IconButton>
              ) : column.dbName === "rut" ? (
                request.rut
              ) : column.dbName === "company.kam.user.name" ? (
                request.company.kam?.user?.email ?? "SIN KAM"
              ) : (
                "SIN INFORMACIÓN"
              )}
            </TableCell>
          );
        })}
      </TableRow>
    </>
  );
}

export default ForSellerAdminRow;
